module.exports = __webpack_public_path__ + "img/hic-female.65c61ab7.png";